export default __webpack_public_path__ + "static/media/collection-card-collections.ff45a4f1.svg";